import { render } from "./FooterView.vue?vue&type=template&id=ad24b9de&scoped=true"
const script = {}

import "./FooterView.vue?vue&type=style&index=0&id=ad24b9de&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad24b9de"]])

export default __exports__